import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from 'styletron-react';
import { useBreakpointMediaQueryMap } from '../../hooks/useBreakpointMediaQueryMap';
const StyledHiderDiv = styled('div', (p) => ({
    [`${p.$breakpoint}`]: {
        display: 'none',
    },
}));
export const ScreenSizeHider = ({ breakPoint, children, type = 'min', }) => {
    const breakpointsMap = useBreakpointMediaQueryMap(type);
    const resultBreakpoint = breakpointsMap[breakPoint];
    return (_jsx(StyledHiderDiv, { $breakpoint: resultBreakpoint, children: children }));
};
